<template>
    <div class="form-panel input" id="inputs">
        <div id="close-bubble"></div>
        <header class="input-header">
            <h2>Application Input</h2>
            <p>See the value in prescriptively applying multiple products <span style="text-wrap: nowrap;">in-furrow</span> simultaneously with our helpful calculator.*</p>
        </header>
        <div class="content">
            <!--Crop-->
            <div class="row black nowrap">
              <div class="labelgroup">
                <label for="crop"><strong>Select a Crop</strong>
                <span class="detail"></span>
                </label>
              </div>
              <div class="field input-top"><!--v-if-->
                <select v-model="selectedCrop" @change="selectNeedOne" name="crop" id="crop" class="select-input" required>
                    <option value="-1" selected disabled>Select</option>
                    <option v-for="(crop) in this.crops.filter(crops => crops.active == true)" :value="this.crops.findIndex(c => c.name === crop.name)" :key="crop.name">{{ crop.name }}</option>
                </select>
                <span></span>
              </div>
            </div>
            <!-- Crop Price -->      
            <div class="row black nowrap">
              <div class="labelgroup">
                <label for="price"><strong>Commodity Price</strong><span class="detail"></span></label>
              </div>
              <div class="field force-dollarsign dollarsign--corn input-top">
                <span class="dollarsign">$</span>
                <input type="number" id="price" name="price" max="999" min="" step="0.01" required=""> 
                <span class="bushel">/Bushel</span>
              </div>
            </div>
            <!-- Farm Size -->
            <div class="row black nowrap">
              <div class="labelgroup">
                <label for="numacres"><strong>No. of Acres&nbsp;Grown</strong></label>
              </div>
              <div class="field input-top">
                <input type="number" id="numacres" name="numacres" max="99999999" min="1" step="1" value="2000" required=""> 
                <span></span>
              </div>
            </div>

            <!--Need/Product Selects -->
            <div class="selects">
                <div class="row black nowrap" id="products">
                <div class="labelgroup">
                    <label for="needOne"><strong>Treatment Need/Product</strong>
                    <span class="detail"></span>
                    </label>
                </div>
                <div class="field nowrap">
                    <div class="labelgroup ">
                        <label for="need1pcg"><strong>Field&nbsp;%</strong>
                        <span class="detail"></span>
                        </label>
                    </div>
                    <span></span>
                </div>
                </div>
                <!--Need Product Selet 1 -->
                <div class="row black nowrap black bg-green">
                <div class="labelgroup">
                    <select v-model="selectedNeedOne" @change="selectNeedTwo" name="needOne" id="needOne" class="productSelect">
                        <option value="-1" selected disabled>Select</option>
                        <option v-for="(need) in needOneOptions" :value="need.id" :key="need.id">{{ need.name }}</option>
                    </select>
                    <br/>
                    <select v-model="selectedNeedOneProduct" name="needOneProduct" id="needOneProduct" class="productSelect" @change="setProductOneDefaults"> 
                        <option value="" selected disabled></option>
                        <option v-for="(products) in needOneProducts" :value="products.id" :key="products.product.name">{{ products.product.name }}</option>
                    </select>
                </div>
                <div class="field black bg-green">
                    <div class="percent-sign"><span>%</span></div>
                    <input type="number" id="need1pcg" name="need1pcg" max="100" min="0" step="1" value="" required="" v-on:keyup="if($event.target.value > 100){$event.target.value = 100; calculate();}"> 
                    <span></span>
                </div>
                </div>
                <!--Need Product Selet 2 -->
                <div class="row black nowrap black bg-yellow">
                <div class="labelgroup">
                    <select v-model="selectedNeedTwo" @change="selectNeedThree" name="needTwo" id="needTwo" class="productSelect">
                        <option value="-1" selected disabled>Select</option>
                        <option v-for="(need) in needTwoOptions" :value="need.id" :key="need.id">{{ need.name }}</option>
                    </select>
                    <br/>
                    <select v-model="selectedNeedTwoProduct" name="needTwoProduct" id="needTwoProduct" class="productSelect" @change="setProductTwoDefaults">   
                        <option value="" selected disabled></option>
                        <option v-for="(products) in needTwoProducts" :value="products.id" :key="products.product.id">{{ products.product.name }}</option>
                    </select>
                </div>
                <div class="field black bg-yellow">
                    <div class="percent-sign"><span>%</span></div>
                    <input type="number" id="need2pcg" name="need2pcg" max="100" min="0" step="1" value="" required="" v-on:keyup="if($event.target.value > 100){$event.target.value = 100; calculate();}"> 
                    <span></span>
                </div>
                </div>
                <!--Need Product Selet 3 -->
                <div class="row black nowrap black bg-light-blue">
                <div class="labelgroup">
                    <select v-model="selectedNeedThree" name="needThree" id="needThree" @change="selectNeedThreeProducts" class="productSelect">
                        <option value="-1" selected disabled>Select</option>
                        <option v-for="(need) in needThreeOptions" :value="need.id" :key="need.id">{{ need.name }}</option>
                    </select>
                    <br/>
                    <select v-model="selectedNeedThreeProduct" name="needThreeProduct" id="needThreeProduct" class="productSelect" @change="setProductThreeDefaults">
                        <option value="" selected disabled></option>
                        <option v-for="(products) in needThreeProducts" :value="products.id" :key="products.product.id">{{ products.product.name }}</option>
                    </select>
                </div>
                <div class="field black bg-light-blue">
                    <div class="percent-sign"><span>%</span></div>
                    <input type="number" id="need3pcg" name="need3pcg" max="100" min="0" step="1" value="" required="" v-on:keyup="if($event.target.value > 100){$event.target.value = 100; calculate();}"> 
                    <span></span>
                </div>
                </div>
            </div>

            <div class="calculate">
                <div id="btnCalculate" class="btn blue" @click="scrollMeTo('simpas-results')">
                    Calculate
                </div>
            </div>
        </div>
        <div ref="simpas-results"></div>
    </div>
    
    <div class="triangle triangle-input">
        <svg class="tri-desk" width="30" height="101" viewBox="0 0 30 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 50.3787L7.45453e-07 100.379L-4.47035e-07 0.378655L30 50.3787Z" fill="#19457F"/>
        </svg>
        <svg class="tri-mobile" width="100" height="31" viewBox="0 0 100 31" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M50 30.3787L1.07281e-05 0.378659L100 0.378662L50 30.3787Z" fill="#19457F"/>
        </svg>
    </div>
</template>

<script>
// @ is an alias to /src
export default {
    name: 'InputForm',
    props: ['inputFormProp'],
    components: {},
    data() {
        /*
            SIMPAS Farmer Benefit Calculator data and formulas based on provided spreadsheet:
            SIMPAS Farm-Specific Benefit Calculator Tool - Simplified - With client inputs.xlsx
        */
        const productCategories = [
                { id: 0,  name: "Nematode Control", pcg: 35, active: true },
                { id: 1,  name: "Pythium Disease Management", pcg: 35, active: false },
                { id: 2,  name: "Fusarium/Rhizoctonia Disease Management", pcg: 35, active: false },
                { id: 3,  name: "Insect Mgmt Area", pcg: 35, active: true },
                { id: 4,  name: "Micro Deficiency Area", pcg: 25, active: true },
                { id: 5,  name: 'Fungal Control', pcg: 25, active: false },
                { id: 6,  name: 'Inoculant Area', pcg: 25, active: false },
                { id: 7,  name: 'N Fixing Area', pcg: 25, active: true },
                { id: 8,  name: 'IDC Area', pcg: 25, active: true },
                { id: 9,  name: 'Soil Health Management', pcg: 25, active: true },
            ];

        const products = [
                { name: "COUNTER 20G", category: 0, active: true, isSaS: true, allAcresPerformanceFee: false },
                { name: "Bacillus firmus (Votivo)", category: 0, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "AZTEC HC", category: 3, active: true, isSaS: true, allAcresPerformanceFee: false },
                { name: "Mefenoxam (Apron)", category: 1, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Pyraclostrobin (Headline)", category: 2, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Azoxystrobin (Quadris)", category: 2, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Tebupirimphos (Aztec HC)", category: 3, active: false, isSaS: true, allAcresPerformanceFee: false },
                { name: "Tefluthrin (Force)", category: 3, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "ZINC Micronutrient", category: 4, active: true, isSaS: true, allAcresPerformanceFee: false },
                { name: "Manganese (Manganese Sulfate)", category: 4, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Aldicarb (Temik)", category: 0, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Pasteuria Nishizawae (Clariva pn)", category: 0, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Mefenoxam (Ridomil Gold)", category: 1, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Metalaxyl (Allegiance)", category: 1, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Clothianidin (Poncho)", category: 3, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Thiamethoxam (Cruiser)", category: 3, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Sulfur", category: 4, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Abamectin (Avicta)", category: 0, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Aldicarb (Temik)", category: 3, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Imidacloprid (Gaucho)", category: 3, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Boron", category: 4, active: false, isSaS: false, allAcresPerformanceFee: false },
                { name: "Force 10G HL", category: 3, active: true, isSaS: true, allAcresPerformanceFee: false },
                { name: "Envita", category: 7, active: true, isSaS: true, allAcresPerformanceFee: false },
                { name: "Ridomil Gold GR", category: 5, active: false, isSaS: true, allAcresPerformanceFee: false },
                { name: "Rhizo-Flo", category: 6, active: false, isSaS: true, allAcresPerformanceFee: false },
                { name: "microSync IRON IDC", category: 8, active: true, isSaS: true, allAcresPerformanceFee: false },
                { name: "iNvigorate", category: 9, active: true, isSaS: true, allAcresPerformanceFee: false },
                { name: "microSync Pro MINI", category: 4, active: true, isSaS: true, allAcresPerformanceFee: false },
            ];

        return {
            selectedCrop: -1,
            cropOptions:[],

            selectedNeedOne: -1,
            needOneOptions:[],
            selectedNeedOneProduct: -1,
            needOneProducts:[],

            selectedNeedTwo:-1,
            needTwoOptions:[],
            selectedNeedTwoProduct: -1,
            needTwoProducts:[],

            selectedNeedThree: -1,
            selectedNeedThreeProduct: -1,
            needThreeOptions:[],
            needThreeProducts:[],

            parentMessage: 'Parent',
            items: [
                //{ id: 'fieldsize', label: 'Target Field Size', detail: 'Acres', value: '125', classes: 'black nowrap', info: 'InfoDetails', after: '', min: 1, max: 99999, step: 1 },
                //{ id: 'numacres', label: 'Total Farm Size', detail: 'Acres', value: '2000', classes: 'black nowrap', info: '', after: '', min: 1, max: 99999999, step: 1 },
                //{ id: 'need1pcg', label: 'Nematode Control Problem Area', detail: '', value: productCategories[0].pcg, classes: 'green nowrap', info: 'Nematode estimates are based on the cost of applying COUNTER<sup>®</sup>', after: '', min: 0, max: 100, step: 1, isPercent: true },
                //{ id: 'need2pcg', label: 'Corn Rootworm Mgmt. Area', detail: '', value: productCategories[1].pcg, classes: 'brown nowrap', info: 'Corn Rootworm estimates are based on the cost of applying AZTEC<sup>®</sup> HC.', after: '', min: 0, max: 100, step: 1, isPercent: true },
                //{ id: 'need3pcg', label: 'Micronutrient Deficiency Area', detail: '', value: productCategories[4].pcg, classes: 'blue nowrap', info: 'Micronutrient estimates are based on the cost of applying ZINC', after: '', min: 0, max: 100, step: 1, isPercent: true },
                //{ id: 'fee', label: 'Agronomist/Retailer Prescription&nbsp;Fee', detail: '', value: '1.00', classes: 'black nowrap', info: 'May not be applicable to all situations. Based on individual retailer.', after: '', min: 0.00, max: 99.00, step: 0.01, isDollars: true, prefixClass: "force-dollarsign dollarsign--fee"  },
                { id: 'price', label: 'Current Price of Corn', detail: '', value: 4.25, classes: 'black wrap', info: '', after: '/Bushel', min: 1.00, max: 999.00, step: 0.01, isDollars: true, prefixClass: "force-dollarsign dollarsign--corn" }
            ],
            BUFFER_ZONE_SIZE: 0.30,
            BUFFER_ZONE_YIELD: 0.50,
            SAS_SOLUTION_AMVACSHARE_AMOUNT: 0.2247,
            SAS_SOLUTION_RETAILER_SHARE_AMOUNT: 0.11,
            // PERFORMANCE_VALUE_FEE: 0.25,
            totalsCalculated: false,
            crops: [{
                name: "Corn",
                price: 3.80,
                active: true,
                need1Category: 0,
                need2Category: 1,
                need3Category: 4,
                categoryLabels: [
                    { id: 1, label: 'Corn Rootworm' }
                ],
                categories: [
                    productCategories[0],
                    productCategories[3],
                    productCategories[4],
                    productCategories[7],
                    productCategories[9]
                ],
                // id must be the position in the products array
                products: [
                    { // COUNTER 20G
                        id: 0,
                        product: products[0],
                        costPerAcre: 33.10,
                        yieldIncreaseNPZ: 6,
                        yieldIncreasePZ: 10
                    },
                    { // AZTEC HC
                        id: 1,
                        product: products[2],
                        costPerAcre: 34.66,
                        yieldIncreaseNPZ: 5,
                        yieldIncreasePZ: 7
                    },
                    { // Force 10G HL
                        id: 2,
                        product: products[21],
                        costPerAcre: 37.12,
                        yieldIncreaseNPZ: 5,
                        yieldIncreasePZ: 6
                    },
                    { // Envita
                        id: 3,
                        product: products[22],
                        costPerAcre: 17.85,
                        yieldIncreaseNPZ: 6,
                        yieldIncreasePZ: 8
                    },
                    { // iNvigorate
                        id: 4,
                        product: products[26],
                        costPerAcre: 7.88,
                        yieldIncreaseNPZ: 3,
                        yieldIncreasePZ: 5
                    },
                    { // microSync Pro MINI
                        id: 5,
                        product: products[27],
                        costPerAcre: 17.33,
                        yieldIncreaseNPZ: 3,
                        yieldIncreasePZ: 5
                    },
                    // Moved here to display Zinc after microSync Pro MINI
                    { // ZINC Micronutrient
                        id: 6,
                        product: products[8],
                        costPerAcre: 10.92,
                        yieldIncreaseNPZ: 3,
                        yieldIncreasePZ: 5
                    },
                ]
            },
            {
                name: "Soybeans",
                price: 10.40,
                active: true,
                need1Category: 0,
                need2Category: 1,
                need3Category: 4,
                categoryLabels: [],
                categories: [
                    productCategories[4],
                    productCategories[7],
                    productCategories[8],
                    productCategories[9]
                ],
                // id must be the position in the products array
                products: [
                    { // iNvigorate
                        id: 0,
                        product: products[26],
                        costPerAcre: 7.88,
                        yieldIncreaseNPZ: 3,
                        yieldIncreasePZ: 5
                    },
                    { // Envita
                        id: 1,
                        product: products[22],
                        costPerAcre: 17.85,
                        yieldIncreaseNPZ: 2,
                        yieldIncreasePZ: 4
                    },
                    { // microSync IRON IDC
                        id: 2,
                        product: products[25],
                        costPerAcre: 28.77,
                        yieldIncreaseNPZ: 5,
                        yieldIncreasePZ: 7
                    },
                    { // microSync Pro MINI
                        id: 3,
                        product: products[27],
                        costPerAcre: 17.33,
                        yieldIncreaseNPZ: 3,
                        yieldIncreasePZ: 5
                    },
                    // Moved Zinc here to display after microSync Pro MINI
                    { // ZINC Micronutrient
                        id: 4,
                        product: products[8],
                        costPerAcre: 10.92,
                        yieldIncreaseNPZ: 4,
                        yieldIncreasePZ: 5
                    },
                ]
            },
            {
                name: "Cotton",
                price: 0.80,
                active: false,
                need1Category: 0,
                need2Category: 1,
                need3Category: 4,
                categoryLabels: [],
                products: [{
                        product: products[10],
                        costPerAcre: 42.00,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 280
                    },
                    {
                        product: products[17],
                        costPerAcre: 5.00,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 120
                    },
                    {
                        product: products[12],
                        costPerAcre: 10.00,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 250
                    },
                    {
                        product: products[13],
                        costPerAcre: 10.00,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 250
                    },
                    {
                        product: products[4],
                        costPerAcre: 11.00,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 280
                    },
                    {
                        product: products[5],
                        costPerAcre: 10.25,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 280
                    },
                    {
                        product: products[15],
                        costPerAcre: 5.00,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 300
                    },
                    {
                        product: products[19],
                        costPerAcre: 5.00,
                        yieldIncreaseNPZ: 0,
                        yieldIncreasePZ: 300
                    },
                    {
                        product: products[8],
                        costPerAcre: 12.00,
                        yieldIncreaseNPZ: 20,
                        yieldIncreasePZ: 200
                    },
                    {
                        product: products[20],
                        costPerAcre: 8.00,
                        yieldIncreaseNPZ: 20,
                        yieldIncreasePZ: 200
                    }
                ]
            }]
        }
    },
    methods: {
        selectNeedOne: function() {
            var selectedCropIndex = document.getElementById('crop').value;
            if (typeof selectedCropIndex !== 'undefined'){
                this.needOneOptions = this.crops[selectedCropIndex].categories;
            }
            this.needOneProducts = [];
            this.needTwoOptions = [];
            this.needTwoProducts = [];
            this.needThreeOptions = [];
            this.needThreeProducts = [];
            // document.getElementById('p_need1').innerHTML = "";
            // document.getElementById('p_need2').innerHTML = "";
            // document.getElementById('p_need3').innerHTML = "";
            // document.getElementById('np_need1').innerHTML = "";
            // document.getElementById('np_need2').innerHTML = "";
            // document.getElementById('np_need3').innerHTML = "";
            
            this.calculate();
        }, 
        setProductOneDefaults: function() {
            var selectedCropIndex = document.getElementById('crop').value;
            var selectedNeedOneProduct = document.getElementById('needOneProduct').value;
            if (selectedNeedOneProduct.length > 0) {
                var selectedNeedOneProductIndex = this.crops[selectedCropIndex].products.findIndex(p => p.id == selectedNeedOneProduct);
                document.getElementById('need1_yieldIncrease').value = this.crops[selectedCropIndex].products[selectedNeedOneProductIndex].yieldIncreasePZ;
                document.getElementById('need1_np_yieldIncrease').value = this.crops[selectedCropIndex].products[selectedNeedOneProductIndex].yieldIncreaseNPZ;
            }else{               
                document.getElementById('need1_yieldIncrease').value = '';
                document.getElementById('need1_np_yieldIncrease').value = '';
                document.getElementById('need2_yieldIncrease').value = '';
                document.getElementById('need2_np_yieldIncrease').value = '';
            }
            this.calculate();
        },
        setProductTwoDefaults: function() {
            var selectedCropIndex = document.getElementById('crop').value;             
            var selectedNeedTwoProduct = document.getElementById('needTwoProduct').value;
            if (selectedNeedTwoProduct.length > 0) {
                var selectedNeedTwoProductIndex = this.crops[selectedCropIndex].products.findIndex(p => p.id == selectedNeedTwoProduct);                
                document.getElementById('need2_yieldIncrease').value = this.crops[selectedCropIndex].products[selectedNeedTwoProductIndex].yieldIncreasePZ;
                document.getElementById('need2_np_yieldIncrease').value = this.crops[selectedCropIndex].products[selectedNeedTwoProductIndex].yieldIncreaseNPZ;
            }else{               
                document.getElementById('need2_yieldIncrease').value = '';
                document.getElementById('need2_np_yieldIncrease').value = '';

            }
            this.calculate();
        },
        selectNeedTwo: function() {
            var selectedCropIndex = document.getElementById('crop').value;
            var selectedNeedOne = document.getElementById('needOne').value;
            var selectedNeedOneIndex = this.crops[selectedCropIndex].categories.findIndex(c => c.id == selectedNeedOne);

            this.needTwoOptions = [];
            this.needTwoProducts = [];
            this.needThreeOptions = [];
            this.needThreeProducts = [];
            
            //populate need 1 products
            if( selectedCropIndex.length != 0 && selectedNeedOne.length != 0){
                this.needOneProducts = this.crops[selectedCropIndex].products.filter(prod => prod.product.category == selectedNeedOne && prod.product.active == true);
                //set labels for output section            
                document.getElementById('p_need1').innerHTML = this.crops[selectedCropIndex].categories[selectedNeedOneIndex].name;
                document.getElementById('np_need1').innerHTML = this.crops[selectedCropIndex].categories[selectedNeedOneIndex].name;
                //populate category options for need 2          
                this.needTwoOptions = this.crops[selectedCropIndex].categories.filter(cat => cat.id != selectedNeedOne );
                this.selectedNeedTwo = -1;
            }else{
                this.needOneProducts = [];
                this.needTwoProducts = []; 
                this.needThreeProducts = [];
                this.selectedNeedOneProduct = -1;

                this.resetNeedResult(1);
                this.resetNeedResult(2);
                this.resetNeedResult(3);
            }
            this.calculate();
        },
        selectNeedThree: function() {
            var selectedCropIndex = document.getElementById('crop').value;
            var selectedNeedOne = document.getElementById('needOne').value;
            var selectedNeedTwo = document.getElementById('needTwo').value;
            var selectedNeedTwoIndex = this.crops[selectedCropIndex].categories.findIndex(c => c.id == selectedNeedTwo);

            //set product options
            this.needThreeOptions = [];
            this.needThreeProducts = [];

            //set filtered categories            
            this.needThreeOptions = this.crops[selectedCropIndex].categories.filter(cat => cat.id != selectedNeedOne && cat.id != selectedNeedTwo);
            if( selectedCropIndex.length != 0 && selectedNeedTwo.length != 0){
                this.needTwoProducts = this.crops[selectedCropIndex].products.filter(prod => prod.product.category == selectedNeedTwo && prod.product.active == true); 
                //set labels for output section            
                document.getElementById('p_need2').innerHTML = this.crops[selectedCropIndex].categories[selectedNeedTwoIndex].name;
                document.getElementById('np_need2').innerHTML = this.crops[selectedCropIndex].categories[selectedNeedTwoIndex].name;
                this.selectedNeedThree = -1;
            }else{
                this.needTwoProducts = [];
                this.selectedNeedThree = -1;
                this.needThreeOptions = [];
                this.needThreeProducts = [];
                this.resetNeedResult(2);
                this.resetNeedResult(3);
            }
            //this.calculate();
        },        
        selectNeedThreeProducts: function() {
            var selectedCropIndex = document.getElementById('crop').value;
            var selectedNeedThree = document.getElementById('needThree').value;
            var selectedNeedThreeIndex = this.crops[selectedCropIndex].categories.findIndex(c => c.id == selectedNeedThree);
                      
            if( selectedCropIndex.length != 0 && selectedNeedThree.length != 0){
                this.needThreeProducts = this.crops[selectedCropIndex].products.filter(prod => prod.product.category == selectedNeedThree && prod.product.active == true);
                    
                //set labels for output section            
                document.getElementById('p_need3').innerHTML = this.crops[selectedCropIndex].categories[selectedNeedThreeIndex].name;
                document.getElementById('np_need3').innerHTML = this.crops[selectedCropIndex].categories[selectedNeedThreeIndex].name;
            }else{
                this.selectedNeedThreeProduct = -1;
                this.resetNeedResult(3);
            }
            this.calculate();
        },
        setProductThreeDefaults: function() {
            var selectedCropIndex = document.getElementById('crop').value;             
            var selectedNeedThreeProduct = document.getElementById('needThreeProduct').value;
            if (selectedNeedThreeProduct.length > 0) {
                var selectedNeedThreeProductIndex = this.crops[selectedCropIndex].products.findIndex(p => p.id == selectedNeedThreeProduct);                
                document.getElementById('need3_yieldIncrease').value = this.crops[selectedCropIndex].products[selectedNeedThreeProductIndex].yieldIncreasePZ;
                document.getElementById('need3_np_yieldIncrease').value = this.crops[selectedCropIndex].products[selectedNeedThreeProductIndex].yieldIncreaseNPZ;
            }else{               
                document.getElementById('need3_yieldIncrease').value = '';
                document.getElementById('need3_np_yieldIncrease').value = '';
            }
            this.calculate();
        },
        resetNeedResult(needNum){            
            var pcg_field = 'need'+needNum+'pcg';
            var p_yield_field = 'need'+needNum+'_yieldIncrease';
            var np_yield_field = 'need'+needNum+'_np_yieldIncrease';

            var p_need_label = 'p_need'+needNum;
            var np_need_label = 'np_need'+needNum;

            document.getElementById(pcg_field).value = 0;
            document.getElementById(p_yield_field).value = 0;
            document.getElementById(np_yield_field).value = 0;
            
            document.getElementById(p_need_label).innerHTML = '';
            document.getElementById(np_need_label).innerHTML = '';
            this.calculate();
        },
        scrollMeTo(refName) {
            // Get current location's distance from the top of the page
            //const position = window.pageYOffset;
            //console.log(position)
            // Get an element's distance from the top of the page
            const getElemDistance = function(elem) {
                let location = 0;
                if (elem.offsetParent) {
                    do {
                        location += elem.offsetTop;
                        elem = elem.offsetParent;
                    } while (elem);
                }
                return location >= 0 ? location : 0;
            };
            const elem = this.$refs[refName];
            if (elem != null)
            {
                var location = getElemDistance(elem);
                var mq = window.matchMedia("(max-width: 900px)");
                if (mq.matches) {
                    window.scrollTo({
                        top: location - 88,
                        behavior: 'smooth'
                    });
                }
            }
            //console.log('location: ' + location);
        },
        calculateTotals(crop, price, fieldSize, numAcres, need1Pcg, need1Product, need2Pcg, need2Product, need3Pcg, need3Product, need1Yield, need2Yield, need3Yield, np_need1Yield, np_need2Yield, np_need3Yield) {


            const totals = {
                crop: this.crops[crop],
                price: price,
                fieldSize: fieldSize,
                numAcres: numAcres,
                needs: [{
                        fieldpPcg: need1Pcg,
                        product: this.crops[crop].products[need1Product],
                        prescriptiveZoneAcres: fieldSize * (need1Pcg / 100),
                        bufferZoneAcres: 0,
                        costToTreatEntireField: 0.00,
                        revenueFromPrescriptiveZone: 0.00,
                        revenueFromBufferZone: 0.00,
                        totalRevenue: 0.00,
                        netValueNonTreatment: 0.00,
                        revenueLossFromNonTreatment: 0.00,
                        costToTreatPrescriptiveZone: 0.00,
                        netValueTreatment: 0.00,
                        netValueWhole: 0.00,
                        sasAMVACShare: 0.00,
                        sasRetailerShare: 0.00,
                        yieldIncreasePZ: 0,
                        yieldIncreaseNPZ: 0,
                        //agronomistPrescriptionFee: 0.00,
                        // performanceValueFee: 0.00
                    }
                ],
                prescriptiveZoneAcres: 0.00,
                yieldIncreasePZ: 0,
                yieldIncreaseNPZ: 0,
                costPerAcre: 0.00,
                costToTreatEntireField: 0.00,
                revenueFromPrescriptiveZone: 0.00,
                revenueFromBufferZone: 0.00,
                totalRevenue: 0.00,
                netValueNonTreatment: 0.00,
                revenueLossFromNonTreatment: 0.00,
                costToTreatPrescriptiveZone: 0.00,
                netValueTreatment: 0.00,
                netValueWhole: 0.00,
                sasAMVACShare: 0.00,
                sasRetailerShare: 0.00,
                //agronomistPrescriptionFee: 0.00,
                // performanceValueFee: 0.00
            };

            if (need2Product.length > 0){
                var need2 = {
                        fieldpPcg: need2Pcg,
                        product: this.crops[crop].products[need2Product],
                        prescriptiveZoneAcres: fieldSize * (need2Pcg / 100),
                        bufferZoneAcres: 0,
                        costToTreatEntireField: 0.00,
                        revenueFromPrescriptiveZone: 0.00,
                        revenueFromBufferZone: 0.00,
                        totalRevenue: 0.00,
                        netValueNonTreatment: 0.00,
                        revenueLossFromNonTreatment: 0.00,
                        costToTreatPrescriptiveZone: 0.00,
                        netValueTreatment: 0.00,
                        netValueWhole: 0.00,
                        sasAMVACShare: 0.00,
                        sasRetailerShare: 0.00,
                        yieldIncreasePZ: 0,
                        yieldIncreaseNPZ: 0,
                        //agronomistPrescriptionFee: 0.00,
                        // performanceValueFee: 0.00
                    };
                totals.needs.push(need2);    
            }
            if (need3Product.length > 0){
                var need3 = {
                        fieldpPcg: need3Pcg,
                        product: this.crops[crop].products[need3Product],
                        prescriptiveZoneAcres: fieldSize * (need3Pcg / 100),
                        bufferZoneAcres: 0,
                        costToTreatEntireField: 0.00,
                        revenueFromPrescriptiveZone: 0.00,
                        revenueFromBufferZone: 0.00,
                        totalRevenue: 0.00,
                        netValueNonTreatment: 0.00,
                        revenueLossFromNonTreatment: 0.00,
                        //agronomistPrescriptionFee: 0.00,
                        costToTreatPrescriptiveZone: 0.00,
                        netValueTreatment: 0.00,
                        netValueWhole: 0.00,
                        sasAMVACShare: 0.00,
                        sasRetailerShare: 0.00,
                        yieldIncreasePZ: 0,
                        yieldIncreaseNPZ: 0,
                        // performanceValueFee: 0.00
                    };
                totals.needs.push(need3);    
            }


            totals.needs.forEach(
                (item, index) => {
                    
                    var yieldSize = item.product.yieldIncreasePZ;
                    var np_yieldSize = item.product.yieldIncreaseNPZ;
                    if (this.totalsCalculated)
                    {
                        switch (index) {
                            case 0:
                                yieldSize = need1Yield;
                                np_yieldSize = np_need1Yield;
                                break;
                            case 1:
                                yieldSize = need2Yield;
                                np_yieldSize = np_need2Yield;
                                break;
                            case 2:
                                yieldSize = need3Yield;
                                np_yieldSize = np_need3Yield;
                                break;
                        }
                    }
                    item.yieldIncreasePZ = yieldSize;
                    item.yieldIncreaseNPZ = np_yieldSize;

                    //--- Per need calculations
                    item.bufferZoneAcres = item.prescriptiveZoneAcres * this.BUFFER_ZONE_SIZE;
                    item.costToTreatEntireField = fieldSize * item.product.costPerAcre;
                    item.revenueFromPrescriptiveZone = item.prescriptiveZoneAcres * price * item.yieldIncreasePZ;
                    item.revenueFromBufferZone = item.bufferZoneAcres * price * this.BUFFER_ZONE_YIELD * item.yieldIncreasePZ;
                    item.totalRevenue = item.revenueFromPrescriptiveZone; // + item.revenueFromBufferZone;
                    item.netValueNonTreatment = item.totalRevenue - item.costToTreatEntireField;
                    item.revenueLossFromNonTreatment = -item.totalRevenue;
                    item.costToTreatPrescriptiveZone = item.prescriptiveZoneAcres * item.product.costPerAcre;
                    item.netValueTreatment = item.revenueFromPrescriptiveZone - item.costToTreatPrescriptiveZone;
                    
                    //item.agronomistPrescriptionFee = item.prescriptiveZoneAcres * fee;
                    // if ((item.revenueFromPrescriptiveZone - item.costToTreatPrescriptiveZone) > 0.00) {
                    //     if (item.fieldpPcg < 100 || (item.fieldpPcg >= 100 && item.product.product.allAcresPerformanceFee)){
                    //         item.performanceValueFee = (item.revenueFromPrescriptiveZone - item.costToTreatPrescriptiveZone) * this.PERFORMANCE_VALUE_FEE;
                    //     }else{
                    //         item.performanceValueFee = 0;    
                    //     }
                    // }

                    // item.netValueTreatment -= item.performanceValueFee;

                    item.netValueWhole = item.netValueTreatment; // * (numAcres / fieldSize);

                    if (item.product.product.isSaS) {
                        item.sasAMVACShare = ((item.yieldIncreasePZ * price) - item.product.costPerAcre) * this.SAS_SOLUTION_AMVACSHARE_AMOUNT;
                        item.sasRetailerShare = item.sasAMVACShare * this.SAS_SOLUTION_RETAILER_SHARE_AMOUNT;
                    }

                    //--- Total need calculations
                    totals.prescriptiveZoneAcres += item.prescriptiveZoneAcres;
                    totals.yieldIncreasePZ += item.yieldIncreasePZ;
                    totals.yieldIncreaseNPZ += item.yieldIncreaseNPZ;
                    totals.costPerAcre += item.product.costPerAcre;
                    totals.costToTreatEntireField += +item.costToTreatEntireField;
                    totals.revenueFromPrescriptiveZone += item.revenueFromPrescriptiveZone;
                    totals.revenueFromBufferZone += item.revenueFromBufferZone;
                    totals.totalRevenue += item.totalRevenue;
                    totals.netValueNonTreatment += item.netValueNonTreatment;
                    totals.revenueLossFromNonTreatment += item.revenueLossFromNonTreatment;
                    totals.costToTreatPrescriptiveZone += item.costToTreatPrescriptiveZone;
                    totals.netValueTreatment += item.netValueTreatment;
                    totals.netValueWhole += item.netValueWhole;
                    totals.sasAMVACShare += item.sasAMVACShare;
                    totals.sasRetailerShare += item.sasRetailerShare;
                    //totals.agronomistPrescriptionFee += item.agronomistPrescriptionFee;
                    // totals.performanceValueFee += item.performanceValueFee;
                }
            );
            
            return totals;
        },

        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            //return x.toString().split('.')[0] + '.' + x.toString().split('.')[1].toFixed();
        },

        displayDollarValue(value, elementName) {
            var div = document.getElementById(elementName);
            if (div !== null)
                div.innerHTML = "$" + this.numberWithCommas(value);
        },

        displayPercentValue(value, elementName) {
            var div = document.getElementById(elementName);
            if (div !== null)
                div.innerHTML = this.numberWithCommas(value) + "%";
        },

        displayNumberValue(value, elementName, extra) {
            var div = document.getElementById(elementName);
            if (div !== null) {
                if (extra != 'undefined' && extra != null)
                    div.innerHTML = this.numberWithCommas(value) + extra;
                else
                    div.innerHTML = this.numberWithCommas(value);
            }
        },

        displayNumberInputValue(value, elementName) {
            var input = document.getElementById(elementName);
            if (input !== null)
                input.value = value;
        },

        displayNeedNumberValue(value, elementName, index) {
            this.displayNumberValue(value, 'need' + (index + 1) + '_' + elementName);
        },

        displayNeedNumberInputValue(value, elementName, index) {
            this.displayNumberInputValue(value, 'need' + (index + 1) + '_' + elementName);
        },

        displayNeedDollarValue(value, elementName, index) {
            this.displayDollarValue(value, 'need' + (index + 1) + '_' + elementName);
        },
        
        displayNeedPercentValue(value, elementName, index) {
            this.displayPercentValue(value, 'need' + (index + 1) + '_' + elementName);
        },

        displayTotalNumberValue(value, elementName) {
            this.displayNumberValue(value, 'total_' + elementName);
        },

        displayTotalDollarValue(value, elementName) {
            this.displayDollarValue(value, 'total_' + elementName);
        },

        displayTotalPercentValue(value, elementName) {
            this.displayPercentValue(value, 'total_' + elementName);
        },

        displayForms() {
            document.querySelector('.instructions').style.display = "block";
            document.querySelector('#app').classList.add('show-forms');
            document.querySelector('#app').classList.remove('show-home');
        },

        calculate() {
            //const CROP_CORN = 0;
            //const NEED_1_PRODUCT = 0;
            //const NEED_2_PRODUCT = 2;
            //const NEED_3_PRODUCT = 8;

            var crop = document.getElementById("crop").value;
            var need_1_product = document.getElementById("needOneProduct").value;
            var need_2_product = document.getElementById("needTwoProduct").value;
            var need_3_product = document.getElementById("needThreeProduct").value;

            
            //var fieldSize = document.getElementById("fieldsize");
            var numAcres = document.getElementById("numacres");
            //var fee = document.getElementById("fee");
            var price = document.getElementById("price");
            var need1Pcg = document.getElementById("need1pcg");
            var need2Pcg = document.getElementById("need2pcg");
            var need3Pcg = document.getElementById("need3pcg");

            var need1Yield = null;
            var need2Yield = null;
            var need3Yield = null;
            var np_need1Yield = null;
            var np_need2Yield = null;
            var np_need3Yield = null;
            
            need1Yield = document.getElementById("need1_yieldIncrease");
            need2Yield = document.getElementById("need2_yieldIncrease");
            need3Yield = document.getElementById("need3_yieldIncrease");
            np_need1Yield = document.getElementById("need1_np_yieldIncrease");
            np_need2Yield = document.getElementById("need2_np_yieldIncrease");
            np_need3Yield = document.getElementById("need3_np_yieldIncrease");

            if(crop.length != 0 && need_1_product.length != 0 && price.value.length != 0){
                
                var totals = this.calculateTotals(crop, +price.value, +numAcres.value, +numAcres.value, +need1Pcg.value, need_1_product, +need2Pcg.value, need_2_product, +need3Pcg.value, need_3_product, +need1Yield.value, +need2Yield.value, +need3Yield.value, +np_need1Yield.value, +np_need2Yield.value, +np_need3Yield.value);
                
                //--- Prescriptive
                this.displayNumberValue(totals.numAcres, 'resNumAcres', ' Acres');
                //displayNumberValue(totals.fieldSize, 'resFieldSize', ' Acres');
                //displayNumberValue(totals.fieldSize, 'fieldSize');
                this.displayDollarValue(totals.netValueTreatment.toFixed(2), 'netValueTreatment');
                this.displayDollarValue(totals.netValueWhole.toFixed(2), 'netValueWhole');

                //--- Non-Prescriptive
                this.displayNumberValue(totals.numAcres, 'np_resNumAcres', ' Acres');
                this.displayDollarValue(totals.netValueNonTreatment.toFixed(2), 'np_netValueWhole');

                totals.needs.forEach(
                    (item, index) => {
                        //--- Prescriptive
                        this.displayNeedNumberValue(item.prescriptiveZoneAcres.toFixed(), 'prescriptiveZoneAcres', index);
                        this.displayNeedNumberInputValue(item.yieldIncreasePZ.toFixed(0), 'yieldIncrease', index);
                        this.displayNeedDollarValue(item.revenueLossFromNonTreatment.toFixed(2), 'revenueLossFromNonTreatment', index);
                        //this.displayNeedDollarValue(item.agronomistPrescriptionFee.toFixed(), 'fee', index);
                        this.displayNeedDollarValue(item.costToTreatPrescriptiveZone.toFixed(2), 'costToTreatPrescriptiveZone', index);
                        this.displayNeedDollarValue(item.revenueFromPrescriptiveZone.toFixed(2), 'revenueFromPrescriptiveZone', index);
                        // this.displayNeedDollarValue(item.performanceValueFee.toFixed(2), 'performanceValueFee', index);
                        this.displayNeedDollarValue(item.netValueTreatment.toFixed(2), 'netValueTreatment', index);
                        this.displayNeedDollarValue(item.netValueWhole.toFixed(2), 'netValueWhole', index);

                        //--- Non-Prescriptive
                        this.displayNeedNumberValue(totals.numAcres.toFixed(), 'np_prescriptiveZoneAcres', index);
                        this.displayNeedNumberInputValue(item.yieldIncreaseNPZ.toFixed(0), 'np_yieldIncrease', index);
                        this.displayNeedDollarValue(item.revenueLossFromNonTreatment.toFixed(2), 'np_revenueLossFromNonTreatment', index);
                        this.displayNeedDollarValue(item.costToTreatEntireField.toFixed(2), 'np_costToTreatEntireField', index);
                        this.displayNeedDollarValue(item.revenueFromPrescriptiveZone.toFixed(2), 'np_revenueFromPrescriptiveZone', index);
                        this.displayNeedDollarValue(item.netValueNonTreatment.toFixed(2), 'np_netValueWhole', index);
                    }
                );

                //--- Prescriptive
                this.displayTotalNumberValue(totals.prescriptiveZoneAcres.toFixed(), 'prescriptiveZoneAcres');
                this.displayTotalNumberValue(totals.yieldIncreasePZ.toFixed(0), 'yieldIncrease');
                this.displayTotalDollarValue(totals.revenueLossFromNonTreatment.toFixed(2), 'revenueLossFromNonTreatment');
                //this.displayTotalDollarValue(totals.agronomistPrescriptionFee.toFixed(), 'fee');
                this.displayTotalDollarValue(totals.costToTreatPrescriptiveZone.toFixed(2), 'costToTreatPrescriptiveZone');
                this.displayTotalDollarValue(totals.revenueFromPrescriptiveZone.toFixed(2), 'revenueFromPrescriptiveZone');
                // this.displayTotalDollarValue(totals.performanceValueFee.toFixed(2), 'performanceValueFee');
                this.displayTotalDollarValue(totals.netValueTreatment.toFixed(2), 'netValueTreatment');
                this.displayTotalDollarValue(totals.netValueWhole.toFixed(2), 'netValueWhole');

                //--- Non-Prescriptive
                this.displayTotalNumberValue((totals.numAcres * 3).toFixed(), 'np_prescriptiveZoneAcres');
                this.displayTotalNumberValue(totals.yieldIncreaseNPZ.toFixed(0), 'np_yieldIncrease');
                this.displayTotalDollarValue(totals.revenueLossFromNonTreatment.toFixed(2), 'np_revenueLossFromNonTreatment');
                this.displayTotalDollarValue(totals.costToTreatEntireField.toFixed(2), 'np_costToTreatEntireField');
                this.displayTotalDollarValue(totals.revenueFromPrescriptiveZone.toFixed(2), 'np_revenueFromPrescriptiveZone');
                this.displayTotalDollarValue(totals.netValueNonTreatment.toFixed(2), 'np_netValueWhole');

                //--- Payback Form
                // If the #payback form exists then place the prescriptive netValueWhole value as the #annualreturn value
                var annualreturn = document.getElementById("annualreturn");
                if (annualreturn) {
                    var event = new Event('change');
                    annualreturn.value = this.numberWithCommas(totals.netValueWhole.toFixed(2));
                    // Now let's tell the payback form annualreturn event handler to update the payback time
                    annualreturn.dispatchEvent(event);
                }
            }
            if (!this.totalsCalculated)
            {
                var numInputs = document.querySelectorAll('input[type=number]')
                numInputs.forEach((input) => {
                    input.addEventListener('change', (e) => {
                    if (e.target.value == '' || e.target.value == 0) {
                        e.target.value = e.target.min;
                        this.calculate();
                    }
                    })
                });

                numInputs.forEach((input) => {
                    input.addEventListener('input', () => {
                        this.calculate();
                    })
                })
            }
            this.totalsCalculated = true;
        }
    },
    mounted: function() {}
}
</script>